module.exports = __webpack_public_path__ + "img/marketwatch.a230753.png";